/* src/app/components/lead-details/participant-information/lead-additional-demographics/lead-additional-demographics.component.css */
/*# sourceMappingURL=lead-additional-demographics.component-ZNFXNWH2.css.map */
